import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings';
import { defaultEstimatesDialog } from './common/planDefaults';
import {
  nightShiftPerk,
  shiftOngoingKeyDetails,
  shiftVicKeyDetails,
} from './common/shiftPlanContent';
import { InternetOfferPerk } from './common/internetOfferPerk';

export const originNightShiftContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Night Shift']),
  content: {
    rateDiscountText: {
      defaultState: { defaultFuel: 'Rates variable on an ongoing plan' },
      VIC: { defaultFuel: 'Rates variable on a 12 month energy plan' },
    },
    keyDetails: {
      defaultState: { defaultFuel: shiftOngoingKeyDetails },
      VIC: { defaultFuel: shiftVicKeyDetails },
    },
    perkAccordion: {
      defaultState: {
        defaultFuel: [],
        dual: [InternetOfferPerk, nightShiftPerk],
        electricity: [InternetOfferPerk, nightShiftPerk],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-night-shift.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-night-shift.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-night-shift.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Charge your EV overnight with off-peak electricity rates between 12-6am',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
